"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error when a draft request body is invalid
 * @param {string} body
 */
class DraftBodyNotValidError extends client_library_1.ExtendableError {
    constructor(body) {
        super(`Invalid draft body: ${body}`);
        this.body = body;
    }
}
exports.default = DraftBodyNotValidError;
//# sourceMappingURL=DraftBodyNotValidError.js.map